import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';
import { Spinner } from '@/components/ui/spinner';

/**
 * z-portal (1400) rather than Tailwind's z-50: the overlay has to cover the
 * AppBar (1100) and the chat panel (1200), which still run on MUI's scale.
 */
const SessionCreatingOverlay: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-0 z-portal flex items-center justify-center bg-black/50"
    >
      <Card className="flex items-center gap-4 p-8">
        <Spinner label="" />
        <span className="revy-cjk text-sm leading-[1.5]">
          {t('drbfm.processing.creatingSession')}
        </span>
      </Card>
    </div>
  );
};

export default SessionCreatingOverlay;
